/**
 * Header Navigation - Hamburger Menu
 * Handles slide-in navigation menu open/close functionality
 */

(function () {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }

  function initMobileNav() {
    const hamburgerBtn = document.querySelector('.js-hamburger');
    const nav = document.querySelector('.mobile-nav');
    const navPanel = nav ? nav.querySelector('.mobile-nav__panel') : null;
    const closeBtn = document.querySelector('.js-nav-close');
    const overlay = document.querySelector('.js-nav-overlay');

    if (!hamburgerBtn || !nav || !closeBtn || !navPanel) {
      return;
    }

    // Initialize focus trap for mobile navigation panel (not the entire nav)
    var focusTrap = window.BellavoraFocusTrap && window.BellavoraFocusTrap.initFocusTrap
      ? window.BellavoraFocusTrap.initFocusTrap(navPanel)
      : null;

    // Store reference to trigger button for focus return
    var triggerButton = hamburgerBtn;

    // Store transition handler reference for cleanup
    var currentTransitionHandler = null;
    var currentTimeout = null;

    // Open navigation
    function openNav() {
      nav.setAttribute('aria-hidden', 'false');
      hamburgerBtn.setAttribute('aria-expanded', 'true');
      closeBtn.setAttribute('aria-expanded', 'true');

      // Activate focus trap first
      if (focusTrap) {
        focusTrap.activate();
      }

      // Focus management - move focus to first focusable element
      // Wait for CSS transition to complete (600ms) before focusing
      var focusApplied = false;

      function applyFocus() {
        if (focusApplied) return;
        focusApplied = true;

        if (window.BellavoraFocusTrap && window.BellavoraFocusTrap.getFocusableElements) {
          var focusables = window.BellavoraFocusTrap.getFocusableElements(navPanel);
          var firstElement = focusables.first;
          if (firstElement) {
            firstElement.focus();
          } else {
            // Fallback to close button if no focusable elements found
            closeBtn.focus();
          }
        } else {
          // Fallback to close button if focus trap utility not available
          closeBtn.focus();
        }
      }

      // Clean up any existing handlers
      if (currentTransitionHandler) {
        navPanel.removeEventListener('transitionend', currentTransitionHandler);
      }
      if (currentTimeout) {
        clearTimeout(currentTimeout);
      }

      // Listen for transition end (checking for transform property specifically)
      currentTransitionHandler = function (e) {
        if (e.propertyName === 'transform' || e.propertyName === 'opacity') {
          applyFocus();
          navPanel.removeEventListener('transitionend', currentTransitionHandler);
          currentTransitionHandler = null;
          if (currentTimeout) {
            clearTimeout(currentTimeout);
            currentTimeout = null;
          }
        }
      };

      navPanel.addEventListener('transitionend', currentTransitionHandler);

      // Fallback timeout in case transitionend doesn't fire (600ms + small buffer)
      currentTimeout = setTimeout(function () {
        applyFocus();
        if (currentTransitionHandler) {
          navPanel.removeEventListener('transitionend', currentTransitionHandler);
          currentTransitionHandler = null;
        }
        currentTimeout = null;
      }, 650);
    }

    // Close navigation
    function closeNav() {
      nav.setAttribute('aria-hidden', 'true');
      hamburgerBtn.setAttribute('aria-expanded', 'false');
      closeBtn.setAttribute('aria-expanded', 'false');

      // Clean up transition handlers
      if (currentTransitionHandler) {
        navPanel.removeEventListener('transitionend', currentTransitionHandler);
        currentTransitionHandler = null;
      }
      if (currentTimeout) {
        clearTimeout(currentTimeout);
        currentTimeout = null;
      }

      // Deactivate focus trap
      if (focusTrap) {
        focusTrap.deactivate();
      }

      // Return focus to the trigger button
      if (triggerButton) {
        setTimeout(function () {
          triggerButton.focus();
        }, 0);
      }
    }

    // Event listeners
    hamburgerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openNav();
    });

    closeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      closeNav();
    });

    // Close on overlay click
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          closeNav();
        }
      });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') {
        closeNav();
      }
    });

    // Close navigation when clicking on a link (optional - for better UX)
    const navLinks = nav.querySelectorAll('.mobile-nav__link');
    navLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        // Small delay to allow navigation to occur
        setTimeout(closeNav, 100);
      });
    });

    // Re-initialize on section reload (Theme Editor support)
    document.addEventListener('shopify:section:load', function (event) {
      if (event.detail.sectionId && document.querySelector('.js-hamburger')) {
        // Re-initialize if this section was reloaded
        initMobileNav();
      }
    });
  }

  /**
   * Sticky Header Scroll Detection
   * Adds 'is-scrolled' class to header when page is scrolled
   */
  function initStickyHeader() {
    const header = document.querySelector('.section-header');

    if (!header) {
      return;
    }

    let ticking = false;

    function updateHeaderState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderState);
        ticking = true;
      }
    }

    // Initial check
    updateHeaderState();

    // Listen for scroll events
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Initialize sticky header
  initStickyHeader();
})();
